if($('.imageSection').length){
    $('.imageSection .image img').each(function(){
        var $this = $(this);
        $this.colorbox({
            rel: 'gallery',
            href: $this.attr('src'),
            title: $this.closest('.image').find('.caption').text(),
            maxWidth: '95%',
            maxHeight: '95%',
            photo: true,
            current: "{current} z {total}",
            className: "customImageColorbox"
            //slideshow: true,
           // slideshowSpeed: 5000,
  
        });
    });
}

if($('.in-pobocky').length){
    $('footer#footer').before($('.text iframe[src*="https://www.google.com/maps/"]'))
}

if($('.imagesGallery').length){
    $('.imagesGallery  .imageGal img').each(function(){
        var $this = $(this);
        $this.colorbox({
            rel: 'gallery',
            href: $this.attr('src'),
            title: $this.attr('alt'),
            maxWidth: '95%',
            maxHeight: '95%',
            photo: true,
            current: "{current} z {total}",
            className: "customImageColorbox"
            //slideshow: true,
           // slideshowSpeed: 5000,
  
        });
    });
  }